import { PartnerRestClient } from "@roberty/rest"

const RestClient = new PartnerRestClient()

export default RestClient